import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { updateUserProfile } from '../api/userService';
import './PhonePromptModal.css';

/**
 * Shown to already-registered users who have no phone number on record.
 * Appears on every page after login until they either save a phone
 * or dismiss it for the current tab session ("Remind Me Later").
 */
const PhonePromptModal = () => {
  const { user, setUser } = useAuth();
  const [phone, setPhone] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [dismissed, setDismissed] = useState(
    () => sessionStorage.getItem('phonePromptDismissed') === '1'
  );

  if (!user) return null;
  if (user.phone) return null;
  if (dismissed) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    const digits = phone.replace(/[\s\-()]/g, '');
    if (!/^\+?\d{10,15}$/.test(digits)) {
      setError('Please enter a valid phone number (10-15 digits, optional country code).');
      return;
    }

    setLoading(true);
    try {
      const { data } = await updateUserProfile({ phone: digits });
      setUser(data.user);
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to save phone number.');
    } finally {
      setLoading(false);
    }
  };

  const handleRemindLater = () => {
    sessionStorage.setItem('phonePromptDismissed', '1');
    setDismissed(true);
  };

  return (
    <div className="phone-prompt-overlay">
      <div className="phone-prompt-card">
        <h2>📱 Add Your Phone Number</h2>
        <p className="phone-prompt-sub">
          Hi {user.name || 'there'}! We now use phone numbers for sign-in
          and account security. Please add yours to continue.
        </p>

        {error && <div className="phone-prompt-error">{error}</div>}

        <form onSubmit={handleSubmit}>
          <label htmlFor="pp-phone">Phone Number</label>
          <input
            id="pp-phone"
            type="tel"
            autoFocus
            autoComplete="tel"
            value={phone}
            onChange={(e) => setPhone(e.target.value)}
            placeholder="+91 98765 43210"
            disabled={loading}
          />

          <div className="phone-prompt-actions">
            <button
              type="button"
              className="phone-prompt-btn secondary"
              onClick={handleRemindLater}
              disabled={loading}
            >
              Remind Me Later
            </button>
            <button
              type="submit"
              className="phone-prompt-btn primary"
              disabled={loading}
            >
              {loading ? 'Saving…' : 'Save Phone'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default PhonePromptModal;
